import { useAuth } from "@/contexts/AuthContext";
import { TimerReset, LogOut } from "lucide-react";

// Countdown popup shown during the last 60s of inactivity before auto logout.
export function IdleTimeoutWarning() {
  const { idleRemaining, extendSession, logout } = useAuth();
  if (idleRemaining == null) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-[2px]" data-testid="idle-warning-overlay">
      <div className="bg-white border-2 border-amber-400 shadow-2xl w-[92%] max-w-md p-6" data-testid="idle-warning-modal">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 flex items-center justify-center bg-amber-100 text-amber-700 rounded-full shrink-0">
            <TimerReset size={20} />
          </div>
          <div>
            <div className="text-sm font-black uppercase tracking-wider text-slate-800">Still there?</div>
            <div className="text-xs text-slate-500">You've been inactive for a while.</div>
          </div>
        </div>
        <p className="text-sm text-slate-700 mb-4">
          For security, you'll be signed out in{" "}
          <span data-testid="idle-warning-countdown" className="font-black text-amber-700 tabular-nums">{idleRemaining}s</span>{" "}
          unless you choose to stay signed in.
        </p>
        <div className="flex gap-2">
          <button
            data-testid="idle-stay-signed-in-btn"
            onClick={extendSession}
            className="flex-1 bg-[#F97316] hover:bg-[#EA580C] text-white font-bold uppercase tracking-wider text-xs py-2.5 transition-colors"
          >
            Stay Signed In
          </button>
          <button
            data-testid="idle-logout-now-btn"
            onClick={logout}
            className="flex items-center justify-center gap-1.5 px-4 border border-slate-300 text-slate-600 hover:bg-slate-50 font-bold uppercase tracking-wider text-xs py-2.5 transition-colors"
          >
            <LogOut size={13} /> Logout
          </button>
        </div>
      </div>
    </div>
  );
}
